import { Environment, ServerConfig } from "../types";

const serverConfig: { [key in Environment]: ServerConfig } = {
  development: {
    domain: "https://api-dev.my.evidationtest.com/api",
  },
  local: {
    domain: "http://localhost:8080/api",
  },
  production: {
    domain: "https://api.us.evidation.com/api",
  },
  stage: {
    domain: "https://api-stage.us.evidation.com/api",
  },
  test: {
    domain: "https://api-test.us.evidation.com/api",
  },
};

export default serverConfig;
